import { PRO } from "../api";

export const SUCCESS = "success";
export const ERROR = "error";

/** URL pública de la web (no del backoffice). En local la web suele ir en el puerto 5173. */
export const WEB_URL =
  process.env.REACT_APP_WEB_URL ||
  (PRO ? "https://actedi.cat" : "http://localhost:5173");

export const LICENSE_KEY_EDITOR = process.env.REACT_APP_API_KEY_EDITOR;
export const API_KEY_TRANSLATOR = process.env.REACT_APP_API_KEY_TRANSLATOR;
